module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-03-large-98fe7afca54bce2413bea8431c17c04c.jpg";